// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const userApi = baseApi.injectEndpoints({
  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    addUser: builder.mutation({
      query: (user) => {
        return {
          url: "add_user",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateUser: builder.mutation({
      query: ({ modifiedData, userSlug }) => {
        return {
          url: `users/${userSlug}`,
          method: "PATCH",
          body: modifiedData,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteUser: builder.mutation({
      query: (userSlug) => {
        return {
          url: `users/${userSlug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllUsers: builder.query({
      query: () => {
        return {
          url: "users",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useGetAllUsersQuery,
} = userApi;
